import { ThemeOptions } from '@mui/material';

export const PaletteColors = {
    main: '#004269',
    dark: '#003250',
    light: '#1BC1F0',
    secondary_main: '#f50057',
    white: '#ffffff',
    light_grey: '#E5E5E5',
    error_main: '#F55454',
}

export const themeOptions: ThemeOptions = {
    palette: {
        mode: 'dark',
        primary: {
            main: PaletteColors.main,
            dark: PaletteColors.dark,
            light: PaletteColors.light,
        },
        secondary: {
            main: PaletteColors.secondary_main,
        },
        white: {
            main: PaletteColors.white
        },
        background: {
            paper: PaletteColors.dark,
            default: PaletteColors.white,
        },
        error: {
            main: PaletteColors.error_main,
        },
        divider: PaletteColors.light_grey,
        text: {
            primary: PaletteColors.white,
            secondary: PaletteColors.light,
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderWidth: '.15rem',
                    borderColor: PaletteColors.white,
                    borderRadius: '1.5rem',
                    padding: '.1rem 2rem .1rem 2rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                    margin: '.2rem',
                },
                outlinedPrimary: {
                    borderColor: PaletteColors.dark,
                },
                containedPrimary: {
                    padding: '1rem 2rem  1rem 2rem',
                    fontSize: '1.2rem',
                    borderRadius: '2rem',
                },
                containedSizeSmall: {
                    borderRadius: '1.5rem',
                    padding: '.1rem 1.5rem .1rem 1.5rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    backgroundColor: PaletteColors.dark
                }
            },
        }
    },
    typography: {
        fontFamily: [
            'Saira',
            'Roboto',
            'sans-serif'].join(','),
    },
};


declare module '@mui/material/styles' {
    interface Theme {
        status: {
            danger: string;
        };
    }

    interface ThemeOptions {
        status?: {
            danger?: string;
        };
    }

    interface Palette {
        white: Palette['primary'];
    }


    interface PaletteOptions {
        white?: PaletteOptions['primary'];
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        white: true;
    }
}
